import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Save, LinkIcon } from "lucide-react";
import { api } from "../lib/api";

export default function ImpostazioniPanel() {
    const [link, setLink] = useState("");
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        api.get("/impostazioni")
            .then((res) => setLink(res.data.wa_catalog_link || ""))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const salva = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            await api.put("/admin/impostazioni", { wa_catalog_link: link });
            toast.success("Impostazioni salvate!");
        } catch {
            toast.error("Salvataggio non riuscito.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <section className="border border-line bg-card p-6 md:p-8 max-w-2xl" data-testid="admin-impostazioni">
            <h2 className="font-display text-2xl font-extrabold tracking-tight flex items-center gap-3">
                <LinkIcon className="h-5 w-5 text-primary" />
                Link offerte del mese (WhatsApp)
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                Incolla qui il link del tuo catalogo WhatsApp con le super
                offerte del mese: le schede "Elettrodomestici" e "Vorwerk
                Folletto" e le card "Vendita elettrodomestici" / "Vendita
                ricambi Folletto" apriranno direttamente il catalogo in chat.
                Se lo lasci vuoto, aprono comunque la chat con un messaggio
                già pronto.
            </p>
            {loading ? (
                <p className="mt-6 font-mono text-xs uppercase tracking-widest text-muted-foreground">
                    Caricamento…
                </p>
            ) : (
                <form onSubmit={salva} className="mt-6 space-y-3">
                    <input
                        data-testid="admin-impostazioni-wacatalog"
                        className="w-full bg-background border border-line px-4 py-3 text-sm focus:outline-none focus:border-primary transition-colors placeholder:text-muted-foreground/60"
                        placeholder="es. https://wa.me/c/XXXXXXXXXXXX"
                        value={link}
                        onChange={(e) => setLink(e.target.value)}
                    />
                    <p className="text-xs leading-relaxed text-muted-foreground">
                        Come trovare il link: nell'app WhatsApp Business apri
                        Strumenti aziendali → Catalogo → condividi il catalogo →
                        copia il link.
                    </p>
                    <button
                        type="submit"
                        data-testid="admin-impostazioni-salva"
                        disabled={saving}
                        className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3 font-display font-bold text-sm tracking-tight hover:bg-primary/90 transition-colors disabled:opacity-60"
                    >
                        {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
                        {saving ? "Salvo…" : "Salva impostazioni"}
                    </button>
                </form>
            )}
        </section>
    );
}